import { Component, OnInit } from '@angular/core';
import { Observable } from "rxjs";
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
declare var require: any;
@Component({
  selector: 'obsjwe-obsidiam-jwe',
  template: `
    <p>
      Estas usando la libreria JWE Obsidiam
    </p>
  `,
  styles: [
  ]
})
export class ObsidiamJweComponent implements OnInit {

  private keyJwe;
  constructor() {
    this.keyJwe = environment.keyJwe;
    this.encriptJweSecret();
  }

  ngOnInit(): void {
  }

  async encodeJwe(validateJwe, param, callback) {

    if (validateJwe) {
      const jose = require('node-jose');

      var opts = {
        algorithms: [{
          "alg": "A256KW",
          "enc": "A128GCM"
        }],
        format: "compact",
        k: this.keyJwe
      };

      return await jose.JWK.asKey({
        algorithms: [{
          "alg": "A256KW",
          "enc": "A128GCM"
        }],
        kty: "oct",
        k: btoa(this.keyJwe),
        alg: "A256KW"
      }).
        then(key => {
          return jose.JWE.createEncrypt(opts, key).final(JSON.stringify(param), "utf8")
            .then(function (response) {
              callback(response);
            });
        });
    } else {
      return callback(param);
    }

  }


  async decodeJwe(codejwe) {

    const jose = require('node-jose');

    return await jose.JWK.asKey({
      algorithms: [{
        "alg": "A256KW",
        "enc": "A128GCM"
      }],
      kty: "oct",
      k: btoa(this.keyJwe),
      alg: "A256KW"
    })
      .then(key => {
        return jose.JWE.createDecrypt(key)
          .decrypt(codejwe)
          .then(res => res.payload.toString())
          .then(payload => JSON.parse(payload))
          .then(response => {
            return response;
          })
      });
  }


  public mapObservable(observable: Observable<any>) {
    return observable.pipe(map(res => {
      return this.decodeJwe(res);
    }));
  }

  private encriptJweSecret() {
    var newJwe = "";
    for (let i = 0; i < this.keyJwe.length - 1; i = i + 2) {
      newJwe = newJwe + this.keyJwe[i + 1];
      newJwe = newJwe + this.keyJwe[i];
    }
    this.keyJwe = newJwe;
  }
}
